import http from '@/service/http'

const fetch = async ({ commit }) => {
  const response = await http.get('/tipo-usuario')
  if (response !== null) {
    const tiposUsuarios = response.data
    commit('SET_LIST', tiposUsuarios)
  }
}

export default {
  fetch
}



// WEBPACK FOOTER //
// ./src/features/admin/tiposUsuarios/store/actions.js